module.exports = __webpack_public_path__ + "img/thumbnail_JapaneseRaccoonDog_f_normal.0655b72d.png";